import ClubEmployeeTeamRelation from '../dto/ClubEmployeeTeamRelation';
import Error from '../model/Error';
import Member from '../dto/Member';
import MemberWithAttendances from '../dto/MemberWithAttendances';
import Team from '../dto/Team';
import axios from 'axios';

export default class TeamRepository {

    static findAll(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/teams`)
                .then(response => resolve(response.data.data.map(data => Team.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(departmentId, team) {
        return new Promise((resolve, reject) => {
            const data = {
                name: team.name,
                sportId: team.sportId,
                hideMembersFromEachOther: team.hideMembersFromEachOther,
                enableChat: team.enableChat,
            };

            axios
                .post(`/club/departments/${departmentId}/teams`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static find(teamId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/teams/${teamId}`)
                .then(response => resolve(Team.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(teamId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/teams/${teamId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(team) {
        return new Promise((resolve, reject) => {
            const data = {
                departmentId: team.departmentId,
                name: team.name,
                hideMembersFromEachOther: team.hideMembersFromEachOther,
                enableChat: team.enableChat,
                sportId: team.sportId,
            };

            axios
                .put(`/club/teams/${team.id}`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateAll(teams) {
        return Promise.all(teams.map(team => this.update(team)));
    }

    static findEmployees(teamId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/teams/${teamId}/employees`)
                .then(response => resolve(response.data.data.map(data => ClubEmployeeTeamRelation.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findMembers(teamId, status, type, search, sort, limit, offset) {
        let params = {
            status,
            type,
            sort,
            limit,
            offset
        };
        if (search !== null) {
            params.search = search;
        }
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/teams/${teamId}/members?include=academicTitle`, { params })
                .then(response => resolve(response.data.data.map(data => Member.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findMemberAttendancesForDay(teamId, date, search, attendancesOnly, openAttendancesOnly) {
        const params = {
            date,
            search,
            attendancesOnly,
            openAttendancesOnly
        };
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/teams/${teamId}/member-attendances`, { params })
                .then(response => resolve(response.data.data.map(data => MemberWithAttendances.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateMemberAttendance(attendanceId, start, end) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/team-member-attendances/${attendanceId}`, {start, end})
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeMemberAttendance(attendanceId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/team-member-attendances/${attendanceId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static uploadImage(team, image, progressCallback) {
        const config = {
            onUploadProgress: function (progressEvent) {
                if (progressCallback) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    progressCallback(percentCompleted);
                }
            },
            headers: {'Content-Type': 'application/octet-stream'}
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/teams/${team.id}/image`, image, config)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeImage(team) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/teams/${team.id}/image`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
